$(document).ready(function(){
$('.ast_featured.multiple-items').slick({
  infinite: false,
  arrows: true,
  dots: true,
  nextArrow: '<button class="slide-arrow next-arrow"><svg class="chevron--right" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M9 18.7913L15 12.7913L9 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',  
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M15 18.7913L9 12.7913L15 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$(window).scroll(function(){ 
if ($('.ast_related.multiple-item').length) {
   
 if ($('.ast_related.multiple-item.slick-initialized.slick-slider').length) {} else {
   
  $(".ast_related.multiple-item").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
  arrows: true,
  dots: false,
  nextArrow: '<button class="slide-arrow next-arrow"><svg class="chevron--right" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M9 18.7913L15 12.7913L9 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',  
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M15 18.7913L9 12.7913L15 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
   } 
 }
 });

$('.ast_block.multiple-block_items').slick({
  infinite: false,
  arrows: true,
  dots: true,
  nextArrow: '<button class="slide-arrow next-arrow"><svg class="chevron--right" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M9 18.7913L15 12.7913L9 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',  
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M15 18.7913L9 12.7913L15 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  slidesToShow: 4,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        adaptiveHeight: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        adaptiveHeight: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});  

$(".product .product-form__input.ast_product_variants_1 .ast_swatch_img").hover(function(){
  var name = $(this).attr('data-value-title');
  $('.product-form__input.ast_product_variants_1 label.form__label .selected__value').text('(' + name +')');
});
$(".product .product-form__input.ast_product_variants_2 .ast_swatch_img").hover(function(){
  var name = $(this).attr('data-value-title');
  $('.product-form__input.ast_product_variants_2 label.form__label .selected__value').text('(' + name +')');
}); 
$(".product .product-form__input.ast_product_variants_3 .ast_swatch_img").hover(function(){
  var name = $(this).attr('data-value-title');
  $('.product-form__input.ast_product_variants_3 label.form__label .selected__value').text('(' + name +')');
});    

$(".product .product-form__input .ast_swatch_img").hover(function(){
  var name = $(".product__media-item.grid__item.slider__slide.is-active" ).attr('data-alt');
   console.log(name);
});

$(".ast_mega_menu .mega-menu__content-inner .mega-menu__list .ast-mega-menu__list").hover(function () {
    var data_title = $(this).attr("data-title");
    console.log(data_title);
    $(".ctm_menu_collection_data").each(function () {
      var data_value = $(this).attr("data-value");
      if (data_title == data_value) {
        $(this).css("display", "block");
      } else {
        $(this).css("display", "none");
      }
    });
  });

 $(".dropdown__menu-item .ast-sub-menu__list").hover(function () {
    var data_title = $(this).attr("data-title");
    console.log(data_title);
      $(".ctm_submenu_collection_data").each(function () {
      var data_value = $(this).attr("data-value");
      if (data_title == data_value) {
        $(this).css("display", "block");
      } else {
        $(this).css("display", "none");
      }
    });
  }); 
});  


$(document).on('click', '.ast_filter', function(){
  $('.mobile-facets__details').show();
  $('.mobile-facets__details.sort_by').hide();
});
$(document).on('click', '.ast_sort', function(){
  $('.mobile-facets__details').hide();
   $('.ast_Style, .ast_Intention, .ast_Material').hide();
  $('.mobile-facets__details.sort_by').show();
})


$(document).ready(function(){
 $(".non-product span").click(function(){
       $(this).parents('.grid__item').find('.custom_drawer_sec').addClass('right');  
       $(this).parents('.grid__item').find('.non-product-drawer-overlay').addClass('non-product-drawer-overlay-two');   
        $('body').css("overflow", "hidden");  
  });
$(".non-product-drawer-close").click(function(){
        $('.custom_drawer_sec').removeClass('right');  
       $('.non-product-drawer-overlay').removeClass('non-product-drawer-overlay-two');     
         $('body').css("overflow", "unset");  
  });
   });


  $(".ItgMediaAlt.product__media-item").each(function () {
     var data = $(this).attr("data-alt");
    console.log(data);
  });

  $('.product__media-list .product__media-item[data-alt]').hide();

  var getSelectAlt = $(".product__media-list .product__media-item.is-active" ).attr('data-alt');
  $('.product__media-list .product__media-item[data-alt="'+getSelectAlt+'"]').show();


if ($(document).find('.product__media-list > li').length) {

  $(document).find('.product__media-list > li').each(function() {
      if (!$(this).hasClass('ItgMediaAlt')) {
        $(this).show();
      }
  });
  
}

$('.facets__label > input').each(function(index) {
        var inputId = $(this).attr('id');
        inputId = inputId + '-' + (index + 1);
        console.log(inputId);
  $(this).parents('label').attr('for', inputId);
        $(this).attr('id', inputId);
    });

const SwymCheckFilterVal = () => {
  $('#FacetsWrapperDesktop details').each(function() {
    if ( $(this).find('.facets__list.list-unstyled').html() == "") {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  $('#FacetFiltersFormMobile details').each(function() {
    if ( $(this).find('.facets__list.list-unstyled').html() == "") {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
}
setTimeout(function() {
  SwymCheckFilterVal();
},500)
$(window).on('load', function() {
  SwymCheckFilterVal();
});

// Header drawers: scoped keyboard and focus management, with no polling.
(() => {
  let active = null;
  const focusable = drawer => Array.from(drawer.querySelectorAll(
    'a[href],button,input,select,textarea,[tabindex]'
  )).filter(el => !el.disabled && el.tabIndex >= 0 &&
    !el.closest('[inert]') && el.getClientRects().length &&
    getComputedStyle(el).visibility !== 'hidden');

  function close() {
    if (!active) return;
    const { drawer, overlay, trigger, background, overflow, priority, menu, previousPopup, focusSearch } = active;
    active = null;
    document.body.removeAttribute('data-erl-drawer-open');
    drawer.removeEventListener('transitionend', focusSearch);
    if (menu) {
      drawer.classList.add('hide-popup');
      overlay?.classList.add('hidden-overlay');
      if (previousPopup === null) document.body.removeAttribute('active-popup');
      else document.body.setAttribute('active-popup', previousPopup);
    } else {
      drawer.classList.remove('left');
      overlay?.classList.remove('cstm-header-search-overlay-two');
    }
    background.forEach(el => el.removeAttribute('inert'));
    document.body.style.setProperty('overflow', overflow, priority);
    trigger.setAttribute('aria-expanded', 'false');
    if (trigger.isConnected) trigger.focus({ preventScroll: true });
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function open(trigger) {
    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!drawer || active) return;
    const menu = drawer.id === 'menu-drawer';
    const overlay = menu ? drawer.parentElement.querySelector('.theme-menu-popup-overlay') :
      drawer.parentElement.querySelector('.cstm-header-search-overlay');
    const background = [];
    active = { drawer, overlay, trigger, background, menu,
      previousPopup: document.body.getAttribute('active-popup'),
      overflow: document.body.style.getPropertyValue('overflow'),
      priority: document.body.style.getPropertyPriority('overflow') };
    document.body.setAttribute('data-erl-drawer-open', '');
    drawer.removeAttribute('inert');
    drawer.removeAttribute('aria-hidden');
    if (menu) {
      drawer.classList.remove('hide-popup');
      overlay?.classList.remove('hidden-overlay');
      document.body.setAttribute('active-popup', 'mobile-navigation');
    } else {
      drawer.classList.add('left');
      overlay?.classList.add('cstm-header-search-overlay-two');
    }
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const focusSearch = () => {
      if (active?.drawer === drawer && !drawer.contains(document.activeElement)) {
        (drawer.querySelector(menu ? '.theme-popup-close' : 'input[type="search"]') || drawer).focus({ preventScroll: true });
      }
    };
    active.focusSearch = focusSearch;
    requestAnimationFrame(focusSearch);
    drawer.addEventListener('transitionend', focusSearch, { once: true });
    // Keep existing inert state intact; exclude the clickable backdrop.
    for (let branch = drawer; branch.parentElement && branch !== document.body; branch = branch.parentElement) {
      Array.from(branch.parentElement.children).forEach(sibling => {
        if (sibling !== branch && sibling !== overlay && !sibling.hasAttribute('inert')) {
          sibling.setAttribute('inert', '');
          background.push(sibling);
        }
      });
    }
  }

  // Capture only this drawer's controls before legacy generic popup handlers.
  document.addEventListener('click', event => {
    const submenuToggle = event.target.closest('#menu-drawer .dropdown-menu--toggle[aria-controls]');
    if (submenuToggle) {
      const submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));
      if (!submenu) return;
      event.preventDefault();
      event.stopPropagation();
      const expanded = submenuToggle.classList.toggle('menu-expanded');
      submenuToggle.setAttribute('aria-expanded', String(expanded));
      submenu.toggleAttribute('inert', !expanded);
      submenu.setAttribute('aria-hidden', String(!expanded));
      return;
    }
    const trigger = event.target.closest('.itg_header-icon .itg_header-icon-left[aria-controls], .navigation--toggle[aria-controls="menu-drawer"]');
    const closing = active && (event.target.closest('.cstm-search-drawer-close, #menu-drawer > .theme-popup-close') || event.target === active.overlay);
    if (!trigger && !closing) return;
    event.preventDefault();
    event.stopPropagation();
    if (closing) close(); else open(trigger);
  }, true);

  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close();
    } else if (event.key === 'Tab') {
      const items = focusable(active.drawer);
      const first = items[0] || active.drawer;
      const last = items[items.length - 1] || active.drawer;
      const current = document.activeElement;
      if (!active.drawer.contains(current) || current === active.drawer ||
          (event.shiftKey && current === first) || (!event.shiftKey && current === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      }
    }
  }, true);
})();
